<template>
  <div>
    <b-row>
      <b-col>
        <b-card 
          :style="onlyView ? '' : isModalView" 
          no-body 
          :class="{ 'open': visibleBody }">
          <b-card-header 
            style="color: black; font:45px;padding: 0 1px; cursor: pointer;"
            :class="{ 'collapsed': !visibleBody }" 
            :aria-expanded="visibleBody ? 'true' : 'false'" 
            role="tab"
            data-toggle="collapse" 
            @click="onVisibleBody(!visibleBody)"
          >
            <span class="lead collapse-title">
              <strong>EVALUACION PEDIÁTRICA </strong>
            </span>
            <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" />
          </b-card-header>

          <b-collapse v-model="visibleBody" role="tabpanel">

            <b-card-body style="margin:0;">

              <b-alert
                v-if="stLastSemiologia"
                show class="p-2" variant="warning"
              >
                <div class="text-center">
                  <i class="fa-solid fa-lightbulb mx-1"/>
                  Se cargo informacion de la evaluacion pediatrica del {{ stLastSemiologia.fecha }}
                </div>
              </b-alert>

              <div>
                <Prenatales :onlyView="onlyView"/>
                <Natales    :onlyView="onlyView"/>
                <Postnatales :onlyView="onlyView"/>
                <Aiepi       :onlyView="onlyView"/>
              </div>

              <div class="text-right">
                <b-button 
                  v-if="!onlyView" 
                  @click="copyAS400()" 
                  variant="info"
                >
                  AS400 <i class="fas fa-copy" />
                </b-button>
              </div>

            </b-card-body>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { copyText } from "@/shared/helpers";
import Prenatales   from './Prenatales.vue';
import Natales      from './Natales.vue';
import Postnatales  from './Postnatales.vue';
import Aiepi        from './Aiepi.vue';
import AtencionTerapias from "../../../../../atencionMedica/components/AtencionModalView/AtencionTerapias.vue";

export default {
  name: "SemiologiaPediatrica",


  props: {
    onlyView: {
      type: Boolean,
      default: false
    }
  },

  components: {
    Prenatales,
    Natales,
    Postnatales,
    Aiepi,
  },


  data() {
    return {
      fechaCita: null,
      dataPeditarica: null,
      visibleBody: true,
    }
  },


  methods: {
    onVisibleBody(visible) {
      this.visibleBody = visible
    },



    copyAS400() {
      let text = '';

      if (this.stSemPediatrica) {
        const { prenatal, natal, postnatal, aiepi } = this.stSemPediatrica;

        const prenatalText  = [];
        const natalText     = [];
        const postnatalText = [];
        const aiepiText     = [];

        if(prenatal){

          let gestas = 0;
          if(prenatal.partosNaturales || prenatal.cesareas || prenatal.abortos)
            gestas = parseInt(prenatal.partosNaturales) + parseInt(prenatal.cesareas) + parseInt(prenatal.abortos);

          if(prenatal.edadMadre)       prenatalText.push(`Edad de la madre: ${prenatal.edadMadre}`);
          if(prenatal.educacionMadre)  prenatalText.push(`Educación de la madre: ${prenatal.educacionMadre.text}`);
          if(gestas)                   prenatalText.push(`Gestas: ${gestas}`);
          if(prenatal.partosNaturales) prenatalText.push(`Partos naturales: ${prenatal.partosNaturales}`);
          if(prenatal.cesareas)        prenatalText.push(`Cesareas: ${prenatal.cesareas}`);
          if(prenatal.abortos)         prenatalText.push(`Abortos: ${prenatal.abortos}`);
          if(prenatal.nControles)      prenatalText.push(`Controles prenatales: ${prenatal.nControles}`);

          if(prenatal.alimentacion)         prenatalText.push(`Alimentación: ${prenatal.alimentacion.join(", ")}`);
          if(prenatal.enfermedadesEmbarazo) prenatalText.push(`Enfermedades en embarazo: ${prenatal.enfermedadesEmbarazo.text}`);
          if(prenatal.medicacionEmbarazo)   prenatalText.push(`Medicaciones en embarazo: ${prenatal.medicacionEmbarazo}`);
          if(prenatal.tipoSangre)           prenatalText.push(`Grupo sanguineo: ${prenatal.tipoSangre.text}`);
        }

        if(natal){
          if(natal.tipoParto)              natalText.push(`Tipo de parto: ${natal.tipoParto.text}`);
          if(natal.edadGestacional)        natalText.push(`Edad gestacional(semanas): ${natal.edadGestacional}`);
          if(natal.complicaciones?.active) natalText.push(`Complicaciones al nacimiento: ${natal.complicaciones.descripcion}`);
          if(natal.sufrimiento?.active)    natalText.push(`Sufrimiento fetal: ${natal.sufrimiento.descripcion}`);
          if(natal.lloro !== null)         natalText.push(`LLoro al nacer: ${natal.lloro ? 'Si' : 'No'}`);
          if(natal.perimetroEncefalico) natalText.push(`Perímetro cefálico: ${natal.perimetroEncefalico}`);
          if(natal.perimetroAbdominal)  natalText.push(`Perímetro abdominal: ${natal.perimetroAbdominal}`);
          if(natal.perimetroToraxico)   natalText.push(`Perímetro torácico : ${natal.perimetroToraxico}`);
          if(natal.peso)                natalText.push(`Peso: ${natal.peso}`);
          if(natal.talla)               natalText.push(`Talla(cm): ${natal.talla}`);

          if(natal.testApgar.value1) natalText.push(`Test APGAR: ${natal.testApgar.value1} / ${natal.testApgar.value2}`);
        }

        if(postnatal){
          if(postnatal.lactancia?.selected)       postnatalText.push(`Lactancia: ${postnatal.lactancia.selected} - ${postnatal.lactancia.descripcion}`);
          if(postnatal.inmunizaciones)            postnatalText.push(`Inmunizaciones completas: ${postnatal.inmunizaciones.completas ? 'Si' : 'No'} - ${postnatal.inmunizaciones.descripcion}`);
          if(postnatal.reacciones?.selected)      postnatalText.push(`Reaccion postvacunal: ${postnatal.reacciones.selected} - ${postnatal.reacciones.descripcion}`);
          if(postnatal.tamizaje?.active)          postnatalText.push(`Tamizaje metabolico: ${postnatal.tamizaje.descripcion}`);
          if(postnatal.hospitalizaciones?.active) postnatalText.push(`Hospitalizaciones previas: ${postnatal.hospitalizaciones.descripcion}`);
          if(postnatal.respiratorios?.selected)   postnatalText.push(`Reaccion respiratoria: ${postnatal.respiratorios.selected} - ${postnatal.respiratorios.descripcion}`);
          if(postnatal.otrasEnfermedades.length)  postnatalText.push(`Otras enfermedades: ${postnatal.otrasEnfermedades.join(", ")}`);
        }

        if(aiepi){
          // if(aiepi.itemList)  aiepiText.push( aiepi.itemList.map( i => `${i.text}: ${i.inputText}`) );
          if(aiepi.itemsList)  aiepi.itemsList.map( i => aiepiText.push(`${i.text}: ${i.inputText}`) );
          if(aiepi.hallazgos) aiepiText.push(`Hallazgos: ${aiepi.hallazgos}`);
        }

        text = `Evaluación Pediátrica:
  ${prenatalText.length ? '* Prenatales:' : ''}
${prenatalText.length ? prenatalText.map( i => `    - ${i}\n`).join("") : ''}
  ${natalText.length ? '* Natales:' : ''}
${natalText.length    ? natalText.map( i => `    - ${i}\n`).join("") : ''}
  ${postnatalText.length ? '* Postnatales:' : ''}
${postnatalText.length ? postnatalText.map( i => `    - ${i}\n`).join("") : ''}
  ${postnatalText.length ? '* AIEPI:' : ''}
${postnatalText.length ? aiepiText.map( i => `    - ${i}\n`).join("") : ''}
        `
      }

      copyText(text);

      this.$bvToast.toast('El texto ha sido copiado', {
        title: `Copiado`,
        variant: 'success',
      })
    },
    
  },

  computed: {
    ...mapState({
      stSemPediatrica  : state => state.atencionCita.semiologias?.semPediatrica,
      stSemActual      : state => state.atencionCita.semiologias?.semActual,
      stLastSemiologia : state => state.atencionCita.semiologias?.lastSemiologia,
      stFechaCita      : state => state.atencionCita.dataCita?.fechaCita
    }),

    isModalView() {
      return {
        margin: '0',
        border: '1px solid #2980b9',
        padding: '0 10px'
      }
    },
  },


  watch: {
    stSemPediatrica: {
      deep: true,
      immediate: true,
      handler(newValue) {

        if(this.onlyView) return;

        const semData = {
          tipo: 'pediatria',
          data: newValue
        }

        semData.data.fechaCita = this.stFechaCita || new Date()

        this.$store.commit("setSemActual", semData)
      }
    },
  }

}
</script>